module.exports = ".userprofile {\n  margin-top: 150px; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/userprofile/userprofile.component.scss
// module id = ./src/app/userprofile/userprofile.component.scss
// module chunks = main